// extracted by mini-css-extract-plugin
export default {"cta":"eE-z","disabled":"fE-z"};